import { Box, Skeleton, Stack } from "@mui/joy";
import { useProject } from "../../../../hooks/query";

import { Timeline as SharedTimelineComponent } from "../../../../shared";

const events: any[] = Array.from({ length: 50 }).map((_, i) => {
    const users = [
        { name: "Samantha Lee", avatarUrl: "https://example.com/avatars/samantha.jpg" },
        { name: "David Cooper", avatarUrl: "https://example.com/avatars/david.jpg" },
        { name: "Alex Rivera", avatarUrl: "https://example.com/avatars/alex.jpg" },
        { name: "Maria Gomez", avatarUrl: "https://example.com/avatars/maria.jpg" },
        { name: "Chris Johnson", avatarUrl: "https://example.com/avatars/chris.jpg" },
        { name: "Ella Tran", avatarUrl: "https://example.com/avatars/ella.jpg" },
        { name: "Liam Patel", avatarUrl: "https://example.com/avatars/liam.jpg" },
    ];

    const types = ["status-change", "note", "task", "document", "comment", "update", "move"];

    const detailsByType = {
        "status-change": ["In Progress", "Completed", "Pending Review", "On Hold"],
        note: [
            "Inspected east gutter – small crack found.",
            "Waterproof membrane needs replacement.",
            "Team arrived late due to supply delays.",
            "Customer requested shingle samples.",
        ],
        task: [
            "Schedule inspection with homeowner",
            "Order new composite shingles",
            "Contact city inspector",
            "Book crane for material lift",
        ],
        document: [
            "Inspection_Report_April2025.pdf",
            "Permit_Approval_Form.pdf",
            "Warranty_Document.pdf",
            "Shingle_Color_Samples.pdf",
        ],
        comment: [
            "Let’s confirm delivery timing with supplier.",
            "Please double-check measurements for skylights.",
            "Attach photos from drone inspection.",
            "Estimate seems higher than expected — discuss?",
        ],
        update: [
            "Updated checklist with new safety steps.",
            "Adjusted task deadlines after rain delay.",
            "Clarified scope in client proposal.",
            "Added link to roof material specs.",
        ],
        move: ["Final Review", "Backlog", "In Progress", "Client Review"],
    } as any;

    const type = types[Math.floor(Math.random() * types.length)];
    const detailsOptions = detailsByType[type] || ["N/A"];
    const user = users[Math.floor(Math.random() * users.length)];
    const date = new Date(Date.now() - Math.random() * 1000 * 60 * 60 * 24 * 10); // last 10 days

    return {
        id: `event-${(i + 1).toString().padStart(3, "0")}`,
        type,
        user,
        date: date.toISOString(),
        details: detailsOptions[Math.floor(Math.random() * detailsOptions.length)],
    };
});

export function Timeline() {
    const { useListById } = useProject();
    const listProjectSvc = useListById();

    const isLoading = listProjectSvc.isPending;

    return (
        <Box m={2} ml={3} mt={-2}>
            {isLoading ? (
                <Stack spacing={3} mt={4} p={1}>
                    {[...Array(6)].map((_, i) => (
                        <Box key={i} display="flex" gap={2} alignItems="flex-start">
                            <Skeleton variant="circular" width={28} height={28} />
                            <Stack spacing={0.5} sx={{ flex: 1 }}>
                                <Skeleton variant="text" width="60%" height={14} />
                                <Skeleton variant="text" width="90%" height={24} sx={{ mt: 0.5 }} />
                            </Stack>
                        </Box>
                    ))}
                </Stack>
            ) : (
                <SharedTimelineComponent events={events} />
            )}
        </Box>
    );
}
